import { AutocompleteWithControlsConfig } from '@shared/modules/autocomplete-with-controls';
import { NotHighlightPristineErrorStateMatcher } from '@shared/classes/not-highlight-pristine-error-state-matcher';
import { CustomsFeeInformer } from './invoice-information.models';

export const TotalCostErrors = {
  required: 'Це поле обов\'язкове',
  rateInvalid: 'Немає даних курсу валют',
  // Separate errors for case when InvoiceCheckbox is checked and not
  totalCostTooHigh: 'Перевищено допустиму сумарну оголошену цінність',
  invoiceCostTooHigh: 'Перевищено допустиму сумарну оголошену цінність',
};

export const TotalWeightErrors = {
  required: 'Це поле обов\'язкове',
  // Separate errors for case when InvoiceCheckbox is checked and not
  totalWeightTooHigh: 'Перевищено фактичну вагу відправлення',
  invoiceWeightTooHigh: 'Перевищено фактичну вагу відправлення',
};

export const TotalCostInCurrentCurrencyErrors = {
  required: 'Це поле обов\'язкове',
};

export const negativeSignAndZeroPattern = /-|^0+/g;

export enum CurrencyCodes {
  EUR = '978',
  USD = '840',
  GBP = '826',
  CAD = '124',
  UAH = '980',
}

export enum CurrencyCodesAlpha3 {
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
  CAD = 'CAD',
  UAH = 'грн',
}

export enum CustomsFeePayer {
  Sender = 'Sender',
  Recipient = 'Recipient',
}

export const CustomsFeePayerTranslation = {
  [CustomsFeePayer.Sender]: 'Відправник',
  [CustomsFeePayer.Recipient]: 'Одержувач',
};

export enum Incoterm {
  DDP = 'DDP',
  DAP = 'DAP',
}

export const CurrencyDict = Object.entries(CurrencyCodes).map(([key, value]) => ({ Code: value, CurrencyAlfa3: key }));

export const configCondition: AutocompleteWithControlsConfig = {
  ariaLabel: 'Умови поставки',
  placeholder: 'Умови поставки',
  arrow: true,
  errorStateMatcher: new NotHighlightPristineErrorStateMatcher(),
};

export const configWeightUnit: AutocompleteWithControlsConfig = {
  ariaLabel: '',
  placeholder: '',
  arrow: false,
  errorStateMatcher: new NotHighlightPristineErrorStateMatcher(),
};

export const configCurrentCurrency: AutocompleteWithControlsConfig = {
  ariaLabel: 'Валюта',
  placeholder: 'Валюта',
  arrow: false,
  errorStateMatcher: new NotHighlightPristineErrorStateMatcher(),
};

export const configCurrency: AutocompleteWithControlsConfig = {
  ariaLabel: 'Валюта інвойсу',
  placeholder: 'Валюта інвойсу',
  arrow: true,
  errorStateMatcher: new NotHighlightPristineErrorStateMatcher(),
};

export enum EInvoiceInformationControlNames {
  base = 'InvoiceInformation',
  totalCost = 'totalCost',
  totalCostInCurrentCurrency = 'totalCostInCurrentCurrency',
  currentCurrency = 'currentCurrency',
  totalWeight = 'totalWeight',
  weightUnit = 'weightUnit',
  currency = 'currency',
  conditions = 'conditions',
  customsFeePayer = 'customsFeePayer',
}

export const PayerFeesCustomsDictionary: { [key in CustomsFeePayer]: string } = {
  [CustomsFeePayer.Sender]: 'b128d80b-70d6-11e8-9296-0025b502a04e',
  [CustomsFeePayer.Recipient]: 'b1295231-70d6-11e8-9296-0025b502a04e',
};

export const CustomsFeePayerServiceIds: { CustomsFee: string, CustomsFeeCanada: string } = {
  CustomsFee: '0f8efdbf-bcd5-45fc-b487-a7067c881f8e',
  CustomsFeeCanada: '7557a866-976e-44f8-bec9-a519f2fcbd45',
};

export const CustomsFeePayerControlDefaultValue: CustomsFeePayer | '' = CustomsFeePayer.Recipient;

export const CustomsFeeInformers: Record<string, CustomsFeeInformer> = {
  PartiallyCalculated: {
    title: 'Митні платежі розраховано не повністю',
    text: 'Для окремих позицій не вдалося визначити HS-код країни призначення, тому сума' +
      ' митних платежів є попередньою та може бути змінена після митного оформлення.',
  },
  NotCalculated: {
    title: 'Митні платежі буде розраховано після перевірки інвойсу',
    text: 'Для клієнтського інвойсу автоматичний розрахунок митних платежів недоступний. Остаточну суму' +
      ' буде визначено після опрацювання інвойсу працівниками компанії.'
  },
  PreliminaryCalculation: {
    title: 'Зверніть увагу: наведений розрахунок є попереднім',
    text: 'Остаточна сума може змінитись під час фактичного проходження митного контролю та буде зафіксована за фактом виставлення платежу',
  }
};
